<template>
  <base-picture
    :alt="content.alt"
    class="base-picture"
    :height="content.height"
    :src="content.url"
    :width="content.width"
  />
</template>

<script lang="ts" setup>
import type { CMSPicture } from '#types/media'

const { content } = defineProps<{ content: CMSPicture }>()
</script>
